import './loading-indicator.scss'

import LoadingGIF from '@Assets/icons/loading-anim.gif'

const CLASS_NAME = 'loading-indicator'

export const LoadingIndicator = ({ active }: { active: boolean }) => {
  if (!active) {
    return null
  }
  return (
    <div className={`${CLASS_NAME}`}>
      <img className={`${CLASS_NAME}__animation`} src={LoadingGIF} alt={'Loading'} />
    </div>
  )
}
